export enum BackupMode {
  Manual = 'manual',
  Auto = 'auto',
}
